export const numberWithComma = (number) => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatCurrency = (price) => {
  const fractionDigits = price < 0.01 ? 6 : 2;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(price);
};

export const stringToNumber = (value) => {
  if (/^\d+(\.\d+)?$/.test(value)) {
    return numberWithComma(parseFloat(value));
  }
  return value;
};

export const findLongestString = (arr) => {
  if (arr.length === 0) {
    return null;
  }

  let longestString = arr[0];
  let longestAbovevalue = arr[0];

  for (let i = 1; i < arr.length; i++) {
    if (arr[i].name.length > longestString.name.length) {
      longestString = arr[i];
    }
    if (arr[i].above && arr[i].above.length > longestAbovevalue.above.length) {
      longestAbovevalue = arr[i];
    }
  }
  return longestAbovevalue.above
    ? longestString.name.length + longestAbovevalue.above.length
    : longestString.name.length;
};
export const removeSpaces = (str) => {
  return str ? str.replace(/\s+/g, "") : str;
};
export const formatPrice = (price) => {
  if (price < 0.01) {
    return price.toFixed(6);
  }
  return price.toFixed(2);
};
export const formatStakingCurrency = (value) => {
  if (!value) return "";
  const number = parseInt(value.replace(/[^\d]/g, ""), 10);
  if (isNaN(number)) return "";
  return `$${number.toLocaleString("en-US")}`;
};
